import {
  fetch as apiFetch,
  postData,
  putData,
} from "../../Component/function/FunctionApi";

// =========================================================
// Endpoints
// =========================================================

const REPRESENTATIVES_URL = "Represntative/get-Represntatives";
const SETTLEMENT_URL = "RepresentativeSettlement";

// =========================================================
// GET: Representatives
// =========================================================

export const fetchRepresentatives = async () => {
  const response = await apiFetch(REPRESENTATIVES_URL);

  const data = response?.data || response || [];

  return Array.isArray(data) ? data : [];
};

// =========================================================
// GET: Summary
// =========================================================

export const fetchSummary = async (filters = {}) => {
  const params = new URLSearchParams();

  // ---------------------------------------------------------
  // RepresentativeId
  // ---------------------------------------------------------

  if (filters.RepresentativeId) {
    params.append(
      "RepresentativeId",
      Number(filters.RepresentativeId)
    );
  }

  // ---------------------------------------------------------
  // Date
  // ---------------------------------------------------------

  if (filters.Date) {
    params.append(
      "Date",
      `${filters.Date}T00:00:00`
    );
  }

  // ---------------------------------------------------------
  // ShippingPerOrder
  // ---------------------------------------------------------

  if (filters.ShippingPerOrder !== "") {
    params.append(
      "ShippingPerOrder",
      Number(filters.ShippingPerOrder)
    );
  }

  // ---------------------------------------------------------
  // ShippingAmount
  // ---------------------------------------------------------

  if (filters.ShippingAmount !== "") {
    params.append(
      "ShippingAmount",
      Number(filters.ShippingAmount)
    );
  }

  // ---------------------------------------------------------
  // Code
  // ---------------------------------------------------------

  if (filters.Code?.trim()) {
    params.append(
      "Code",
      filters.Code.trim()
    );
  }

  // ---------------------------------------------------------
  // Codes[]
  // ---------------------------------------------------------

  if (Array.isArray(filters.Codes)) {
    filters.Codes.forEach((code) => {
      if (String(code).trim()) {
        params.append(
          "Codes",
          String(code).trim()
        );
      }
    });
  }

  // ---------------------------------------------------------
  // Customer
  // ---------------------------------------------------------

  if (filters.Customer?.trim()) {
    params.append(
      "Customer",
      filters.Customer.trim()
    );
  }

  // ---------------------------------------------------------
  // Phone
  // ---------------------------------------------------------

  if (filters.Phone?.trim()) {
    params.append(
      "Phone",
      filters.Phone.trim()
    );
  }

  // ---------------------------------------------------------
  // Address
  // ---------------------------------------------------------

  if (filters.Address?.trim()) {
    params.append(
      "Address",
      filters.Address.trim()
    );
  }

  // ---------------------------------------------------------
  // Governorate
  // ---------------------------------------------------------

  if (filters.Governorate?.trim()) {
    params.append(
      "Governorate",
      filters.Governorate.trim()
    );
  }

  // ---------------------------------------------------------
  // Governorates[]
  // ---------------------------------------------------------

  if (Array.isArray(filters.Governorates)) {
    filters.Governorates.forEach((governorate) => {
      if (String(governorate).trim()) {
        params.append(
          "Governorates",
          String(governorate).trim()
        );
      }
    });
  }

  // ---------------------------------------------------------
  // GovernorateId
  // ---------------------------------------------------------

  if (filters.GovernorateId) {
    params.append(
      "GovernorateId",
      Number(filters.GovernorateId)
    );
  }

  // ---------------------------------------------------------
  // Status
  // ---------------------------------------------------------

  if (filters.Status?.trim()) {
    params.append(
      "Status",
      filters.Status.trim()
    );
  }

  // ---------------------------------------------------------
  // Statuses[]
  // ---------------------------------------------------------

  if (Array.isArray(filters.Statuses)) {
    filters.Statuses.forEach((status) => {
      if (String(status).trim()) {
        params.append(
          "Statuses",
          String(status).trim()
        );
      }
    });
  }

  // ---------------------------------------------------------
  // CategoryName
  // ---------------------------------------------------------

  if (filters.CategoryName?.trim()) {
    params.append(
      "CategoryName",
      filters.CategoryName.trim()
    );
  }

  // ---------------------------------------------------------
  // CategoryId
  // ---------------------------------------------------------

  if (filters.CategoryId) {
    params.append(
      "CategoryId",
      Number(filters.CategoryId)
    );
  }

  // ---------------------------------------------------------
  // MinTotal
  // ---------------------------------------------------------

  if (filters.MinTotal !== "") {
    params.append(
      "MinTotal",
      Number(filters.MinTotal)
    );
  }

  // ---------------------------------------------------------
  // MaxTotal
  // ---------------------------------------------------------

  if (filters.MaxTotal !== "") {
    params.append(
      "MaxTotal",
      Number(filters.MaxTotal)
    );
  }

  // ---------------------------------------------------------
  // represntativeId
  // ---------------------------------------------------------

  if (filters.represntativeId) {
    params.append(
      "represntativeId",
      Number(filters.represntativeId)
    );
  }

  // ---------------------------------------------------------
  // dateDaily
  // ---------------------------------------------------------

  if (filters.dateDaily) {
    params.append(
      "dateDaily",
      filters.dateDaily
    );
  }

  // ---------------------------------------------------------
  // Request
  // ---------------------------------------------------------

  const queryString = params.toString();

  const url = `RepresentativeSettlement/summary${
    queryString ? `?${queryString}` : ""
  }`;

  console.log("GET SUMMARY:", `${url}`);

  const response = await apiFetch(url);

  console.log("SUMMARY RESPONSE:", response);

  return response?.data || response;
};

// =========================================================
// GET: Settlement Records
// =========================================================

export const fetchSettlements = async (
  representativeId,
  selectedDate
) => {
  if (!representativeId || !selectedDate) {
    return [];
  }

  const formattedDate = `${selectedDate}T00:00:00`;

  const params = new URLSearchParams();

  params.append(
    "RepresentativeId",
    representativeId
  );

  params.append(
    "Date",
    formattedDate
  );

  const url = `${SETTLEMENT_URL}?${params.toString()}`;

  console.log("GET SETTLEMENTS:", url);

  const response = await apiFetch(url);

  console.log(
    "SETTLEMENT RECORDS RESPONSE:",
    response
  );

  const data = response?.data || response || [];

  return Array.isArray(data) ? data : [];
};

// =========================================================
// POST: Create Settlement
// =========================================================

export const createSettlement = async (payload) => {
  console.log(
    "CREATE SETTLEMENT PAYLOAD:",
    payload
  );

  return postData(
    SETTLEMENT_URL,
    payload
  );
};

// =========================================================
// PUT: Update Settlement
// =========================================================

export const updateSettlement = async (
  id,
  payload
) => {
  console.log(
    "UPDATE SETTLEMENT:",
    `${SETTLEMENT_URL}/${id}`,
    payload
  );

  return putData(
    `${SETTLEMENT_URL}/${id}`,
    payload
  );
};

// =========================================================
// GET: Payment Methods Summary
// =========================================================

export const fetchPaymentMethodsSummary = async (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.RepresentativeId) {
    params.append(
      "RepresentativeId",
      Number(filters.RepresentativeId)
    );
  }

  if (filters.Date) {
    params.append(
      "Date",
      `${filters.Date}T00:00:00`
    );
  }

  if (filters.FromDate) {
    params.append(
      "FromDate",
      `${filters.FromDate}T00:00:00`
    );
  }

  if (filters.ToDate) {
    params.append(
      "ToDate",
      `${filters.ToDate}T23:59:59`
    );
  }

  if (filters.Status?.trim()) {
    params.append(
      "Status",
      filters.Status.trim()
    );
  }

  const queryString = params.toString();

  const url = `RepresentativeSettlement/payment-methods-summary${
    queryString ? `?${queryString}` : ""
  }`;

  console.log("GET PAYMENT METHODS SUMMARY:", url);

  const response = await apiFetch(url);

  console.log(
    "PAYMENT METHODS SUMMARY RESPONSE:",
    response
  );

  return response?.data || response;
};